export enum IntervalEnum {
    OneMinute = 0,
    TwoMinutes  = 1,
    FiveMinutes  = 2,
    ThirtyMinutes  = 3,
    OneHour = 4,
    FourHours = 5,
    SixHours = 6,
    TwelveHours = 7,
    OneDay = 8,
    OneWeek = 9,
    OneMonth = 10,
    EndOfDay = 11,
    EndOfMonth = 12,
    EndOfYear = 13
  }
  